module.exports = __webpack_public_path__ + "static/media/school_marker.2dc63a79.png";